import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TemplateContext from '../TemplateContext/template-context';
import { SectionHeader } from '@graphcommerce/next-ui';

export default function SelectQuantity(props) {
  const { sx, optionEndLabels, price_tiers } = props;

  const { setQuantity, setChipValue, quantity } = React.useContext(TemplateContext);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  React.useEffect(() => {
    if (price_tiers) {
      if (price_tiers.length > 0) {
        setQuantity(price_tiers[0]?.quantity);
        setChipValue(price_tiers[0]?.final_price.value);
      }
    }
  }, [price_tiers]);

  const handleChange = (event: SelectChangeEvent) => {

    for (let i of price_tiers) {
      if (i.quantity === event.target.value) {
        setQuantity(event.target.value);
        setChipValue(i.final_price.value);
      }
    }
  };

  return (
    <div>
      {price_tiers?.[0] && <div>
        <SectionHeader
          labelLeft={"Choose Quantity"}
          labelRight={optionEndLabels.size}
        />
        <FormControl sx={[
          {
            width: '100%',
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={quantity}
            onChange={handleChange}
            MenuProps={{
              style: { maxHeight: 250 }
            }}
          >
            {price_tiers?.map((item) => (
              <MenuItem key={item.quantity} value={item.quantity}>{item.quantity.toLocaleString(undefined, { maximumFractionDigits: 0 })} chips ({formatter.format(item?.final_price?.value ?? 0)} / chip)</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>}
    </div>
  );
}
